import axios from 'axios';
import { useEffect, useState } from 'react';
import { useUser } from '../../contexts/UserContext';
import sseConsumer, { EventData, WeatherBackgroundEvent } from '../../utils/ServerSideEventConsumer';
import './EventsSegment.css';


function WeatherSegment() {
  const { user } = useUser();
  const [backgroundImage, setBackgroundImage] = useState<string | null>(null);

  const refreshBackgroundImage = async () => {
    const segment = 'weather';
    await axios.post(`${process.env.REACT_APP_API_URL}/refresh/background`,
      { segment },
      {
        withCredentials: true,
        params: {
          forceUser: JSON.parse(process.env.REACT_APP_USER || '{}')?.email,
        }
      }
    )
  }

  useEffect(() => {
    const backgroundCallback = async (streamEvent: EventData) => {
      switch (streamEvent.eventType) {
        case 'weather-background':
          setBackgroundImage(`${process.env.REACT_APP_MEDIA_URL}/${(streamEvent as WeatherBackgroundEvent).imageUrl}`);
          break;
      }
    }

    sseConsumer.registerCallback('weather-background', backgroundCallback);

    return () => {
      sseConsumer.removeCallback('weather-background', backgroundCallback);
    };
  }, []);

  // Fetch events when city location changes
  useEffect(() => {
    const fetchWeatherBackground = async () => {

      try {
        const forceUser = process.env.REACT_APP_USER ? JSON.parse(process.env.REACT_APP_USER)?.email : '';
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/weather/background`,
          {
            withCredentials: true,
            params: {
              forceUser,
            }
          });

        const weatherBackgroundImage = response.data.imageUrl || [];
        setBackgroundImage(`${process.env.REACT_APP_MEDIA_URL}/${weatherBackgroundImage}`);
      } catch (error) {
        console.error('Error fetching weather background image:', error);
      }
    };

    fetchWeatherBackground();
  }, []);

  return (
    <div className="Event flex flex-col h-[calc(100vh-48px)]">
      <main className="relative h-full">
        {backgroundImage ? (
          <img
            src={backgroundImage}
            alt={`Description of ${user?.settings.cityState}`}
            className="absolute inset-0 w-full h-full object-cover"
            onDoubleClick={refreshBackgroundImage}
          />
        ) : (
          <p>Loading weather...</p>
        )}
      </main>
    </div>
  );
}

export default WeatherSegment;